module.exports = __webpack_public_path__ + "img/graph-head-icon.20e5fe88.svg";